export enum JoinMembershipStatus {
    UNKNOWN,
    JOINED,
    NOTJOINED
}